export default __webpack_public_path__ + "static/media/0x6f8a06447ff6fcf75d803135a7de15ce88c1d4ec.3f6b745f.webp";